exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contain[data-v-10a6bdae] {\n  min-height: 80vh;\n  padding-bottom: 20px;\n  background-color: #fff;\n  border-radius: 10px;\n}\n", ""]);

// exports
